import { Omit } from '@40seas/entities/common';
import { TenantlessBaseEntityFieldsArray } from '@40seas/models';
import { InviteStatus } from './invite-status.enum';
import { Invite } from './invite.entity';

export class CreateInviteDto extends Omit(Invite, [...TenantlessBaseEntityFieldsArray, 'inviter'], ['status']) {
    status?: InviteStatus;
}
